"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stack = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("./");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @component
 * @category Atoms
 */
var Stack = function Stack(props) {
  var def = props.type ? props.type : Stack.Type.Row;
  var klassXS = props.xs ? props.xs : def;
  var klassSM = props.sm ? props.sm : def;
  var klassMD = props.md ? props.md : def;
  var klassLG = props.lg ? props.lg : def;
  var klass = props.className ? props.className : '';
  klass += " ".concat(klassXS, "-XS");
  klass += " ".concat(klassSM, "-SM");
  klass += " ".concat(klassMD, "-MD");
  klass += " ".concat(klassLG, "-LG");

  if (props.center) {
    klass += ' center';
  }

  if (props.start) {
    klass += ' start';
  }

  if (props.wrap) {
    klass += ' wrap';
  }

  var styles = props.style ? props.style : {};

  if (props.justifyContent) {
    styles.justifyContent = props.justifyContent;
  }

  if (props.alignItems) {
    styles.alignItems = props.alignItems;
  }

  if (props.alignConent) {
    styles.alignContent = props.alignContent;
  }

  if (props.flexDirection) {
    styles.flexDirection = props.flexDirection;
  }

  var attr = _objectSpread(_objectSpread({}, props), {}, {
    type: null,
    xs: null,
    sm: null,
    md: null,
    lg: null,
    flexDirection: null,
    justifyContent: null,
    alignItems: null,
    alignContent: null,
    center: null,
    className: klass,
    style: styles
  });

  return /*#__PURE__*/_react.default.createElement(_.Element, attr, props.children);
};
/**
 * Type or orientation of the stack component
 * 
 * @readonly
 * @enum {string}
 */


exports.Stack = Stack;
Stack.Type = {
  Column: 'Column',
  Row: 'Row'
};
Stack.propTypes = {
  type: _propTypes.default.oneOf(Object.keys(Stack.Type).map(function (k) {
    return Stack.Type[k];
  })),
  xs: _propTypes.default.oneOf(Object.keys(Stack.Type).map(function (k) {
    return Stack.Type[k];
  })),
  sm: _propTypes.default.oneOf(Object.keys(Stack.Type).map(function (k) {
    return Stack.Type[k];
  })),
  md: _propTypes.default.oneOf(Object.keys(Stack.Type).map(function (k) {
    return Stack.Type[k];
  })),
  lg: _propTypes.default.oneOf(Object.keys(Stack.Type).map(function (k) {
    return Stack.Type[k];
  })),
  center: _propTypes.default.bool,
  start: _propTypes.default.bool,
  justifyContent: _propTypes.default.oneOf(['flex-start', 'flex-end', 'start', 'end', 'left', 'right', 'center', 'space-between', 'space-around', 'space-evenly']),
  alignItems: _propTypes.default.oneOf(['stretch', 'flex-start', 'flex-end', 'center', 'baseline']),
  alignContent: _propTypes.default.oneOf(['normal', 'flex-start', 'flex-end', 'start', 'end', 'center', 'space-between', 'space-around', 'space-evenly', 'stretch'])
};